<template>
  <div id="app">
    <header>
      <h1>Image Gallery</h1>
    </header>
    <main>
      <ImageFilter :categories="categories" @filter="filterImages" />
      <ImageGallery :images="filteredImages" />
    </main>
    <footer>
    <p>&copy; {{ new Date().getFullYear() }} Online Birds. All rights reserved.</p>
  </footer>
  </div>
</template>

<script>
import { imageData } from './data';
import ImageFilter from './components/ImageFilter.vue';
import ImageGallery from './components/ImageGallery.vue';

export default {
  name: 'App',
  components: { ImageFilter, ImageGallery },
  data() {
    return {
      images: imageData,
      filteredImages: imageData,
    };
  },
  computed: {
    categories() {
      const allCategories = this.images.map(img => img.category);
      return ['All', ...new Set(allCategories)];
    }
  },
  methods: {
    filterImages(category) {
      if (category === 'All') {
        this.filteredImages = this.images;
      } else {
        this.filteredImages = this.images.filter(img => img.category === category);
      }
    }
  }
};
</script>

<style lang="scss">
@import './style/main.scss';
</style>